import { TIMELINE_RULER_SLICE_WIDTH } from 'consts'
import { useSelector } from 'react-redux'
import { editorSelectors } from 'store/features/editor/selectors'
import { projectDataSelectors } from 'store/features/projectData/selectors'

export default () => {
  const projectDuration = useSelector(projectDataSelectors.duration)
  const timelineSliceDuration = useSelector(
    editorSelectors.timelineRulerSliceDuration
  )

  return (projectDuration / timelineSliceDuration) * TIMELINE_RULER_SLICE_WIDTH
}
